import { getDomainPrefix, type NovaEnvironment, type SupportedRegions } from "@nova/constants"

export type SharedConfiguration = {
    config: { get(name: "environmentName" | "domain"): string }
    isLocalhostEnvironment: () => boolean
    getApiGatewayDomainForRegion: (
        region?: SupportedRegions,
        environment?: NovaEnvironment
    ) => string
    currentRegion: () => SupportedRegions
}

export const resolveDomain = (environment: string, localhostDomain: () => string) =>
    environment === "localhost"
        ? localhostDomain()
        : `https://${getDomainPrefix(environment)}mapnova.com`

export type Conforms<Facade extends SharedConfiguration> = Facade

export declare const config: SharedConfiguration["config"]
export declare const isLocalhostEnvironment: SharedConfiguration["isLocalhostEnvironment"]
export declare const getApiGatewayDomainForRegion: SharedConfiguration["getApiGatewayDomainForRegion"]
export declare const currentRegion: SharedConfiguration["currentRegion"]
